export const iconFontAwesomeFilesBoxArchive = (
	<i className="fa-solid fa-box-archive"></i>
);
